<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<template>
  <transition name="modal" mode="out-in">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('close')">
        <div class="modal-container" @click.stop>
          <div class="modal-header d-flex flex-row align-items-center">
            <div class="d-flex align-items-center">
              <slot name="header"> </slot>
            </div>
            <div class="ml-auto">
              <button
                @click="$emit('close')"
                class="button-close d-flex align-items-center"
              >
                <i class="material-icons">clear</i>
              </button>
            </div>
          </div>

          <div class="modal-body">
            <slot name="body"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
